import { createCssTransition, createJSTransition } from './createTransition';
import expandTransition from './expandTransition';

// Javascript transitions
export const CdsTransitionExpand = createJSTransition('expand-transition', expandTransition());
export const CdsTransitionExpandX = createJSTransition('expand-transition-x', expandTransition('', true));

export { CdsTransitionModal } from './modalTransition';
export { CdsTransitionCollapse } from './collapseTransition';

// CSS transitions
export const CdsTransitionFade = createCssTransition('fade-transition');
export const CdsTransitionSlideY = createCssTransition('slide-transition-y');
export const CdsTransitionSlideX = createCssTransition('slide-transition-x');
export const CdsTransitionSlideRight = createCssTransition('slide-transition-right');
export const CdsTransitionSlideLeft = createCssTransition('slide-transition-left');
export const CdsTransitionJumpRight = createCssTransition('jump-transition-right');
export const CdsTransitionJumpLeft = createCssTransition('jump-transition-left');
export const CdsTransitionScale = createCssTransition('scale-transition');
export const CdsTransitionModalBottom = createCssTransition('modal-transition-bottom');
export const CdsTransitionModalTop = createCssTransition('modal-transition-top');
